
    import { defineComponent } from 'vue';
    import { Form, Field } from "vee-validate";
    import * as yup from "yup";
    import { AxiosError, AxiosResponse } from 'axios';
    import { debounce } from "debounce";
    import { useProgrammatic } from '@oruga-ui/oruga-next';

    import { useUserStore } from '../../stores/user';

    export default defineComponent({
        components: {
            Form,
            Field
        },
        data() {
            const { oruga } = useProgrammatic();

            type Nullable<T> = null | T;

            function passwordUpdateToast() {
                oruga.notification.open({
                    message: 'Password Updated!',
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 2000,
                    variant: 'success'
                });
            }
            function failureToast(errorMessage: string) {
                oruga.notification.open({
                    message: `${errorMessage}`,
                    rootClass: 'toast-notification',
                    position: 'top',
                    variant: 'danger',
                    duration: 5000,
                    closable: true
                });
            }

            const userStore = useUserStore();

            return {
                passwordUpdateToast,
                failureToast,
                form: {
                    Password: '',
                    Token: this.$route.query.Token,
                } as any,
                ConfirmPassword: '',

                isPageLoading: false as boolean,

                isPasswordValid: true as boolean,
                isPasswordChecking: false as boolean,
                validatePassword: null as Nullable<Function>,

                currentUser: userStore.user,

                displayChangePassword: false
            }
        },
        computed: {
            schema(): object {
                const self: any = this;

                return yup.object().shape({
                    Password: yup
                        .string()
                        .required("Password is required")
                        .max(200, "Max allowed Charactors is 200")
                        .min(8, "Password length must a minimum of 8 characters.")
                        .test('validPassword', 'Password must contain at least 3 of the following symbol, number, uppercase letter or a lowercase letter',
                            () => {
                                return self.isPasswordValid
                            }),
                    ConfirmPassword: yup
                        .string()
                        .required("Confirm Password is required")
                        .oneOf([yup.ref('Password'), null], "Passwords don't match")
                        .max(200, "Max allowed Charactors is 200")
                });
            },



        },
        methods: {
            onSubmit(): void {
                this.isPageLoading = true;

                this.$axios
                    .post('account/ChangePasswordUserForm', this.form)
                    .then(({ data }: AxiosResponse<any>) => {
                        if (data) {
                            this.passwordUpdateToast();
                            this.$router.push('/login');
                        }
                    })
                    .catch((error: AxiosError) => {
                        this.failureToast(error?.response?.data as string);
                    })
                    .finally(() => {
                        this.isPageLoading = false;
                    });
            },

            validatePasswordInput({ target }: InputEvent): void {

                const password = (target as any).value;
                let points = 0;
                let passwordRef: any = this.$refs.passwordInput;

                if (password != '') {
                    this.isPasswordChecking = true;

                    // --- Set the 'Checking userId availability' error message while checking the database. --- //
                    (this.$refs.formValidator as any).setFieldError('Password', 'Checking Password...');

                    if ((/[a-z]/.test(password))) {
                        points++;
                    }

                    if ((/[A-Z]/.test(password))) {
                        points++;
                    }

                    if ((/[0-9]/.test(password))) {
                        points++;
                    }

                    if ((/[~!-@#$%^&\*()_+=`]/.test(password))) { // eslint-disable-line
                        points++;
                    }

                    if (points < 4) {
                        passwordRef.errors = [];
                        setTimeout(() => {
                            // --- Manually trigger validation --- //
                            passwordRef.validate();

                            this.isPasswordChecking = false;
                            this.isPasswordValid = false;

                        }, 250);
                        //return 'Password must contain at least 3 of the following symbol, number, uppercase letter or a lowercase letter';
                    } else {
                        (this.$refs.formValidator as any).setFieldError('Password', '');
                        passwordRef.validate();
                        this.isPasswordChecking = false;
                        this.isPasswordValid = true;
                    }
                }
            },
            verifyTokenExpiration() {
                if (this.form.Token != null && this.form.Token != '') {
                    this.$axios.get('account/VerifyToken', { params: { token: this.form.Token } })
                        .then(({ data }: AxiosResponse<any>) => {
                            if (!data) {
                                this.$router.push('/login');
                            } else {
                                this.displayChangePassword = true;
                            }
                        })
                        .catch((error: AxiosError) => {
                            this.failureToast(error?.response?.data as string);
                        })
                } else {
                    this.$router.push('/login');
                }
            }
        },
        created() {
            this.validatePassword = debounce(this.validatePasswordInput, 500);
            this.verifyTokenExpiration();
        }
    });

